import { useState } from "react"
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

import SportInput from 'components/ProgramGenerator/SportInput'
import ProgressionLevelInput from 'components/ProgramGenerator/ProgressionLevelInput'
import EquipmentProfileInput from 'components/ProgramGenerator/EquipmentProfileInput'

export default function FitnessProfileInputContainer() {

    const [detailsExpanded, setDetailsExpanded] = useState(false)

    return (
        <div className='bg-white border border-gray-400 p-4 rounded-xl space-y-6'>

            {/* Expand Details Toggle */}
            <div 
                className='flex items-center cursor-pointer gap-x-4'
                onClick={() => setDetailsExpanded(!detailsExpanded)}
            >
                <div className='flex-grow'>Fitness Profile</div>
                {!detailsExpanded && <ChevronDownIcon className='w-6 h-6 text-gray-400' />}
                {detailsExpanded && <ChevronUpIcon className='w-6 h-6 text-gray-400' />}
            </div>

            {detailsExpanded && 
                <div className='space-y-4'>

                    <SportInput />

                    <ProgressionLevelInput />

                    <EquipmentProfileInput />

                </div>
            }

        </div>
    )

}